import React from 'react'
import numeral from 'numeral'

// Component
import { Section } from '../../../components'

// Helpers
import { dateMonDayYearTime } from '../../../helpers'

const AuctionInformation = ({ eventData }) => {
  const checkBidDecrementIncrement = () => {
    if (eventData) {
      const biddingReverseType = eventData.bidding_type === 'Reverse'
      const bidDecrementType = eventData.bid_decrement_increment
      return biddingReverseType
        ? bidDecrementType
          ? 'Bid Decrement'
          : 'Minimum Bid Decrement'
        : bidDecrementType
        ? 'Bid Increment'
        : 'Minimum Bid Increment'
    }
  }

  const renderTitle = title => {
    return <label className="title">{title + ' :'}</label>
  }

  const renderDetail = detail => {
    return <label className="detail">{detail}</label>
  }

  return (
    <>
      <Section className="event-no">
        <Section className="row">
          {renderTitle('Event Name')}
          <span className="detail">
            <b>{eventData && eventData.name}</b>
          </span>
        </Section>

        <Section className="row">
          {renderTitle('Event No.')}
          <span className="detail">
            <b>{eventData && eventData.event_no}</b>
          </span>
        </Section>
      </Section>
      <Section className="auction-info">
        <Section className="row">
          <Section className="column">
            {renderTitle('Auction Type')}
            {renderDetail(eventData && eventData.auction_type)}
          </Section>
          <Section className="column">
            {renderTitle('Currency')}
            {renderDetail(eventData && eventData.currency)}
          </Section>
        </Section>
        <Section className="row">
          <Section className="column">
            {renderTitle('Bidding Type')}
            {renderDetail(eventData && eventData.bidding_type)}
          </Section>
          <Section className="column">
            {renderTitle('VAT')}
            {renderDetail(eventData && eventData.vat)}
          </Section>
        </Section>
        <Section className="row">
          <Section className="column">
            {renderTitle('Opening Price')}
            {renderDetail(
              eventData &&
                numeral(eventData.opening_price).format('0,0.00') +
                  ' ' +
                  eventData.currency
            )}
          </Section>
          <Section className="column">
            {renderTitle('Start Time')}
            {renderDetail(
              eventData && dateMonDayYearTime(eventData.start_date)
            )}
          </Section>
        </Section>
        <Section className="row">
          <Section className="column">
            {renderTitle(checkBidDecrementIncrement())}
            {renderDetail(
              eventData &&
                `${numeral(
                  eventData.bid_decrement_increment ||
                    eventData.min_bid_decrement_increment
                ).format('0,0.00')} 
                    ${eventData.currency}`
            )}
          </Section>
          <Section className="column">
            {renderTitle('End Time')}
            {renderDetail(eventData && dateMonDayYearTime(eventData.end_date))}
          </Section>
        </Section>
        <Section className="row">
          <Section className="column">
            {renderTitle('Extension Time')}
            {renderDetail(
              eventData && eventData.extension_minutes
                ? eventData.extension_minutes + ' Minutes'
                : '-'
            )}
          </Section>
          <Section className="column">
            {renderTitle('Max Extension Time')}
            {renderDetail(
              eventData &&
                (eventData.extension_time
                  ? `${eventData.extension_time} Times`
                  : eventData.extension_time_string === 'Unlimited'
                  ? eventData.extension_time_string
                  : '-')
            )}
          </Section>
        </Section>
      </Section>
    </>
  )
}

export default AuctionInformation
